import { Routes } from '@angular/router';
import { cherishGuard } from "../auth/cherish.guard";

export const routes: Routes = [
	{
		path: '',
		title: 'Dartegnian L. Velarde',
		loadComponent: () => import('@pages/home/home.component').then(m => m.HomeComponent),
		pathMatch: 'full'
	},
	{
		path: 'login',
		redirectTo: 'wp-login.php',
		pathMatch: 'full'
	},
	{
		path: 'wp-login',
		redirectTo: 'wp-login.php',
		pathMatch: 'full'
	},
	{
		path: 'wp-login.php',
		title: 'Log In ‹ Dartegnian — WordPress',
		loadComponent: () => import('@pages/horror-login/horror-login.component').then(m => m.HorrorLoginComponent)
	},
	{
		path: 'cherish',
		title: 'Cherish',
		canActivate: [cherishGuard],
		loadComponent: () => import('@pages/cherish/cherish.component').then(m => m.CherishComponent)
	},
	{
		path: 'calendar/:year/:month/:day',
		title: 'Journal Entry | Dartegnian',
		loadComponent: () => import('@pages/calendar-day/calendar-day.component').then(m => m.CalendarDayComponent)
	},
	{
		path: 'ddlc',
		title: 'Doki Doki Literature Club!',
		loadComponent: () => import('@pages/ddlc/ddlc.component').then(m => m.DdlcPageComponent)
	},
	{
		path: '**',
		redirectTo: '/'
	}
];
